import {
  searchFilters,
  searchProducts,
  categoryFilters,
  categoryProducts
} from 'shared/models/api';
import qs from 'query-string';
import _ from 'lodash';
import Promise from 'bluebird';

export const UPDATE = 'FILTER_UPDATE';
export const LOAD = 'FILTER_LOAD_PRODUCTS';
export const LOADING_RESULTS = 'FILTER_LOADING_PRODUCTS';
export const UPDATE_EXPAND = 'FILTER_UPDATE_EXPAND';
export const LOAD_FILTERSET = 'LOAD_FILTERSET';

const init = {
  filterset: [],
  products: [],
  count: 0,
  size: 60,
  loading: false,
  selected: { sort: 'featured', order: 'asc', skip: 0 },
  expand: {}
};

export default function(state = init, action = {}) {
  switch (action.type) {
    case UPDATE:
      action.selected.skip = parseInt(action.selected.skip, 10);
      return { ...state, selected: action.selected };
    case UPDATE_EXPAND:
      return { ...state, expand: action.expand };
    case LOADING_RESULTS:
      return { ...state, loading: true };
    case LOAD:
      return {
        ...state,
        filterset: action.result.filterset,
        products: action.result.products,
        count: action.result.count,
        loading: false
      };
    case LOAD_FILTERSET:
      return {
        ...state,
        filterset: action.filterset
      };
    default:
      return state;
  }
}

export function selectFilters(nextSelected) {
  return dispatch => {
    const selected = { ...init.selected, ...nextSelected };
    dispatch({ type: UPDATE, selected: selected });
  };
}

export function syncWithQueryParams(queryString) {
  return dispatch => {
    return Promise.resolve().then(() => {
      const parsedParams = parseQuery(queryString);
      const selected = { ...init.selected, ...parsedParams };
      dispatch({ type: UPDATE, selected });
    });
  };
}

export function updateFilteredProducts() {
  return (dispatch, getState) => {
    dispatch({ type: LOADING_RESULTS });

    const params = {
      size: getState().filter.size,
      ...getState().filter.selected
    };

    const req = getState().category.searchQuery
      ? searchProducts(getState().category.searchQuery, params)
      : categoryProducts(getState().category.tag, params);

    return req.then(result => {
      result.filterset = mergeFiltersets(
        getState().filter.filterset,
        result.filterset
      );
      dispatch({ type: LOAD, result: result });
    });
  };
}

export function getAvailableFilters() {
  return (dispatch, getState) => {
    dispatch({ type: LOADING_RESULTS });

    const req = getState().category.searchQuery
      ? searchFilters(getState().category.searchQuery)
      : categoryFilters(getState().category.tag);

    return req.then(result => {
      dispatch({ type: LOAD_FILTERSET, filterset: result.filterset });
    });
  };
}

export function resetFilters() {
  return (dispatch, getState) => {
    dispatch({ type: LOADING_RESULTS });

    const selected = { ...init.selected };
    dispatch(selectFilters(selected));

    const params = {
      size: getState().filter.size,
      ...selected
    };

    const req = getState().category.searchQuery
      ? searchProducts(getState().category.searchQuery, params)
      : categoryProducts(getState().category.tag, params);

    return req.then(result => {
      dispatch({ type: LOAD, result });
    });
  };
}

export function updateExpand(expand) {
  return dispatch => dispatch({ type: UPDATE_EXPAND, expand: expand });
}

// always show complete range filters
export function mergeFiltersets(baseFilterset, narrowedFilterset) {
  const merged = narrowedFilterset.map(filter => {
    const baseRangeFilter = _.find(baseFilterset, ['name', filter.name]);
    return filter.type === 'range' && baseRangeFilter
      ? baseRangeFilter
      : filter;
  });
  if (merged.length) return merged;
  return _.filter(baseFilterset, ['type', 'range']);
}

export function pathForSelected(location, selected) {
  let url = location.pathname;
  const queryString = stringify(selected);
  if (queryString) url += '?' + queryString;
  return url;
}

export function stringify(params) {
  let state = { ...params };
  if (state.price) {
    state['price-min'] = state.price.min;
    state['price-max'] = state.price.max;
    delete state.price;
  }
  if (state.order == 'asc') delete state.order;
  if (state.sort == 'featured') delete state.sort;
  if (state.skip == 0) delete state.skip;
  delete state.size;
  return qs.stringify(state);
}

export function parseQuery(queryString) {
  let state =
    typeof queryString === 'string' ? qs.parse(queryString) : queryString;
  if (state['price-min'] && state['price-max']) {
    state.price = {
      min: parseInt(state['price-min']),
      max: parseInt(state['price-max'])
    };
    delete state['price-min'], delete state['price-max'];
  }
  return state;
}



// WEBPACK FOOTER //
// ./shared/components/filter/actions.js